import React, { Component } from 'react'
import { Link } from 'react-router'
import { connect } from 'react-redux'

import classNames from './common.css'
import { fetchAlbumSharedUsers, shareAlbum, unshareAlbum } from '../../redux/share'
import { fetchUsers } from '../../redux/users'
import { fixAlbum, unfixAlbum } from '../../redux/query'
import { saveAlbum } from '../../redux/album'
import { fetchPlaylists, saveList, addAlbumToList, removeAlbumFromList } from '../../redux/playlists'
import LoadingSpinner from '../LoadingSpinner'
import ErrorMessage from '../ErrorMessage'
import Icon from '../Icon'
import ShareButton from '../ShareButton'
import ConfirmButtons from '../ConfirmButtons'
import SaveAlbum from '../modals/SaveAlbum'
import { updateAlbumLists } from '../../utils/lists'

class AlbumShare extends Component {
  state = {
    checked: this.props.sharedUserIDs || [],
    success: false,
    submitting: false,
    savingFixed: false
  }
  componentDidMount () {
    const { users, fetchUsers, sharedUserIDs, fetchAlbumSharedUsers, id } = this.props
    if (!users) {
      fetchUsers()
    }
    if (!sharedUserIDs) {
      fetchAlbumSharedUsers(id).then(ids => {
        this.setState({
          checked: ids
        })
      })
    }
    if (!this.props.lists) {
      this.props.fetchPlaylists()
    }
  }
  componentWillReceiveProps (nextProps) {
    const { id, fetchAlbumSharedUsers } = this.props
    if (id !== nextProps.id) {
      fetchAlbumSharedUsers(nextProps.id).then(ids => {
        this.setState({
          checked: ids
        })
      })
    }
  }
  isFormValid = () => {
    const { users, sharedUserIDs } = this.props
    const { checked } = this.state
    for (let user of users) {
      if (checked.indexOf(user.id) !== -1 && sharedUserIDs.indexOf(user.id) === -1) {
        return true
      }
      if (checked.indexOf(user.id) === -1 && sharedUserIDs.indexOf(user.id) !== -1) {
        return true
      }
    }
    return false
  }
  onSubmit = () => {
    const { id, users, sharedUserIDs, shareAlbum, unshareAlbum } = this.props
    const { checked } = this.state
    const promises = []
    users.forEach(user => {
      if (checked.indexOf(user.id) !== -1 && sharedUserIDs.indexOf(user.id) === -1) {
        promises.push(shareAlbum(id, user.id))
      }
      if (checked.indexOf(user.id) === -1 && sharedUserIDs.indexOf(user.id) !== -1) {
        promises.push(unshareAlbum(id, user.id))
      }
    })
    if (promises.length === 0) {
      return
    }
    this.setState({ submitting: true, success: false, error: null })
    Promise.all(promises).then(
      () => {
        this.setState({
          success: true,
          submitting: false
        })
      },
      error => {
        this.setState({
          error,
          submitting: false,
          checked: this.props.sharedUserIDs
        })
      }
    )
  }
  onClickFixHint = () => {
    this.setState({
      loadingAll: true
    })
    const { loadAllImages, fixAlbum } = this.props
    loadAllImages().then(() => {
      fixAlbum(this.props.images.map(i => i._id))
      this.setState({
        savingFixed: true,
        loadingAll: false
      })
    })
  }
  saveFixed = data => {
    const { saveAlbum, query } = this.props
    const albumData = {
      ...data,
      lists: undefined,
      createList: undefined
    }
    return saveAlbum(albumData, query.structure, data.id, '/album/:id/share')
      .then(album => {
        return updateAlbumLists({
          albumID: album.id,
          checked: data.lists,
          createList: data.createList,
          lists: this.props.lists,
          addAlbumToList: this.props.addAlbumToList,
          removeAlbumFromList: this.props.removeAlbumFromList,
          saveList: this.props.saveList
        })
      }).then(() => {
        this.setState({
          savingFixed: false
        })
      })
  }
  getInitalSaveFormValues = () => {
    const { album } = this.props
    return {
      id: album.id,
      name: album.name,
      cover: album.cover,
      presentation_type: album.presentation_type,
      presentation_speed: album.presentation_speed,
      presentation_transition: album.presentation_transition,
      presentation_sort: album.presentation_sort
    }
  }
  renderUser = user => {
    const { checked } = this.state
    const isChecked = checked.indexOf(user.id) !== -1
    const onCheck = () => this.setState({ checked: checked.concat(user.id), success: false })
    const onUncheck = () => this.setState({ checked: checked.filter(id => id !== user.id), success: false })
    return (
      <li key={user.id}>
        <button
          className={isChecked ? classNames.userChecked : classNames.user}
          onClick={isChecked ? onUncheck : onCheck}>
          <div style={{ flex: 1 }}>
            <div className={classNames.userName}>
              {user.name}
            </div>
            <div className={classNames.userEmail}>
              {user.email}
            </div>
          </div>
          <div className={isChecked ? classNames.checkboxChecked : classNames.checkbox}>
            {isChecked &&
              <Icon icon='tick' className={classNames.tick} size={16} />
            }
          </div>
        </button>
      </li>
    )
  }
  render () {
    const { users, sharedUserIDs, fetching, error, fetchUsers, fetchAlbumSharedUsers, id } = this.props

    if (!users || !sharedUserIDs || fetching) {
      return <LoadingSpinner />
    }

    if (error.users) {
      return (
        <ErrorMessage
          message='There was an error fetching all users'
          onRetry={fetchUsers}
        />
      )
    }

    if (error.shared) {
      return (
        <ErrorMessage
          message='There was an error fetching the list of users this album is shared with'
          onRetry={() => fetchAlbumSharedUsers(id)}
        />
      )
    }

    const { canShareInternal, canShareExternal, showFixHint } = this.props
    const { success, submitting, savingFixed } = this.state

    return (
      <div className={classNames.page}>
        {canShareExternal &&
          <ShareButton path={`/album/${id}`} />
        }
        {canShareInternal &&
          <div>
            {showFixHint &&
              <p className={classNames.note}>
                Note that you are sharing an unlocked album.
              </p>
            }
            {showFixHint &&
              <p className={classNames.note}>
                Images added later that match the search pattern will appear in the album.
              </p>
            }
            {showFixHint &&
              <p className={classNames.note}>
                <button onClick={this.onClickFixHint} className={classNames.link}>Click here</button> to save the album as locked.
              </p>
            }
            {this.state.loadingAll &&
              <LoadingSpinner />
            }
            <ul>
              {users.map(this.renderUser)}
            </ul>
            {success &&
              <p className={classNames.note}>Album sharing was successfully updated</p>
            }
            {this.state.error &&
              <p className={classNames.error}>There was an error sharing the album</p>
            }
            <div className={classNames.buttons}>
              <Link to={`/album/${id}`} className={success ? classNames.button : classNames.backButton}>
                {success ? 'Done' : 'Cancel'}
              </Link>
              {!success &&
                <button onClick={this.onSubmit} className={classNames.button} disabled={submitting || !this.isFormValid()}>
                  {submitting ? ' Submitting…' : 'Submit'}
                </button>
              }
            </div>
          </div>
        }
        {savingFixed &&
          <SaveAlbum
            title={'Save fixed album'}
            onSubmit={this.saveFixed}
            closeModal={() => {
              this.setState({ savingFixed: false })
              this.props.unfixAlbum()
            }}
            initialValues={this.getInitalSaveFormValues()}
            canSave={this.props.canSave}
            lists={this.props.lists}
            albumLists={this.props.albumLists}
            defaultSort={this.props.sort.value + (this.props.sort.operator ? `-${this.props.sort.operator}` : '')}
          />
        }
      </div>
    )
  }
}

const mapStateToProps = ({ users, share, entities, auth }, props) => {
  const sharedUsers = share.internal[props.id] || {}
  return {
    users: users.data && users.data
      .filter(id => id !== entities.albums[props.id].user_id)
      .map(id => entities.users[id]),
    sharedUserIDs: sharedUsers.data,
    fetching: users.fetching || sharedUsers.fetching,
    error: {
      users: users.error,
      shared: sharedUsers.error
    }
  }
}

const mapDispatchToProps = {
  fetchUsers,
  fetchAlbumSharedUsers,
  shareAlbum,
  unshareAlbum,
  fixAlbum,
  unfixAlbum,
  saveAlbum,
  fetchPlaylists,
  addAlbumToList,
  removeAlbumFromList,
  saveList
}

export default connect(mapStateToProps, mapDispatchToProps)(AlbumShare)



// WEBPACK FOOTER //
// ./src/components/album/AlbumShare.js